export const isAddressMismatchError = (error: any) => error?.response?.data?.error === 'UspsAddressMismatchError';
